module.exports = __webpack_public_path__ + "static/media/improve_learning_engagement.f64cff71.jpg";